import React from "react";
import { Link } from "react-router-dom";
import {  mediaUrl } from "./util";
import { gokulam_superspeciality_logo } from "./Image";
import { useData } from "../context/DataContext";

const Footer = () => {
   const data = useData();


  return (
    <>
      <footer className="footer-dark bg-dark-gray pb-0 cover-background background-position-left-top">
        <div className="container">
          <div className="row justify-content-center mb-5 md-mb-8 sm-mb-40px gy-4">
            <div className="col-12 col-lg-12 col-xl-4 last-paragraph-no-margin order-sm-1">
              <Link
                to="/"
                className="footer-logo mb-15px d-inline-block bg-white p-10px rounded-4"
              >
                <img
                  src={
                    data && data.logo
                      ? `${mediaUrl}/${data.logo}`
                      : {gokulam_superspeciality_logo}
                  }
                  alt="Logo"
                />
              </Link>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae
                consequuntur pariatur illo quaerat magni earum repudiandae
                aperiam nam, fuga ducimus temporibus aliquam quam alias est
                laborum doloribus labore. Modi, odit.
              </p>
              <div className="elements-social social-icon-style-02 mt-20px xs-mt-15px">
                <ul className="small-icon light">
                  <li className="my-0">
                    {data?.sociallinks?.facebook && (
                      <a
                        className="facebook"
                        href={data.sociallinks?.facebook}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    )}
                  </li>
                  <li className="my-0">
                    {data?.sociallinks?.twitter && (
                      <a
                        className="twitter"
                        href={data.sociallinks?.twitter}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-twitter"></i>
                      </a>
                    )}
                  </li>
                  <li className="my-0">
                    {data?.sociallinks?.instagram && (
                      <a
                        className="instagram"
                        href={data.sociallinks?.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    )}
                  </li>
                  <li className="my-0">
                    {data?.sociallinks?.youtube && (
                      <a
                        className="youtube"
                        href={data.sociallinks?.youtube}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                    )}
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-6 col-md-6 col-lg-3 col-xl-2 order-sm-3 order-lg-2">
              <span className="fs-17 fw-500 d-block text-white mb-5px">
                Quick links
              </span>
              <ul>
                <li>
                  <Link to="/about-us">About us</Link>
                </li>
                <li>
                  <Link to="/news-events">News & Events</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-6 col-lg-3 col-xl-2 order-sm-3 order-lg-2">
              <span className="fs-17 fw-500 d-block text-white mb-5px">
                Departments
              </span>
              <ul>
                <li>
                  <Link to="/super-specialties">Super Specialties</Link>
                </li>
                <li>
                  <Link to="/general-specialties">Gen. Specialties</Link>
                </li>
                <li>
                  <Link to="/laboratory">Laboratory Dept.</Link>
                </li>
                <li>
                  <Link to="/services">Services Dept.</Link>
                </li>
                <li>
                  <Link to="/supporting">Supporting Dept.</Link>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-6 col-lg-3 col-xl-2 order-sm-4 order-lg-3">
              <span className="fs-17 fw-500 d-block text-white mb-5px">
                Patient Help
              </span>
              <ul>
                <li>
                  <Link to="/appointment">Make An Appointment</Link>
                </li>
                <li>
                  <Link to="/find-doctor">Find Doctor</Link>
                </li>
                <li>
                  <Link to="/opd-schedule">OPD Schedule</Link>
                </li>
                <li>
                  <Link to="/packages">Packages</Link>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-6 col-lg-3 col-xl-2 order-sm-5 order-lg-4">
              <span className="fs-17 fw-500 d-block text-white mb-5px">
                Contact Us
              </span>
              <ul>
                <li>
                  <Link to="/post-query">Post A Query</Link>
                </li>
                <li>
                  <Link to="/book-appointment">Book an Appointment</Link>
                </li>
                <li>
                  <Link to="/feedback">Give Your Feedback</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="row border-top border-color-transparent-white-light pt-35px pb-35px gap-4">
            <div className="col-12">
              <p className="fs-13 m-0 lh-22">
                All rights reserved © Sree Gokulam Super Speciality Hospital&nbsp;
                <span id="footer_year">2024&nbsp;</span>
                Developed by{" "}
                <a
                  href="https://www.logiprompt.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-line-bottom"
                >
                  Logiprompt Techno Solutions India(P) Ltd
                </a>
              </p>
            </div>

            <div className="col-12 d-flex gap-4">
              <Link to="/privacy-policy">Privacy policy</Link>
              <Link to="/disclaimer">Disclaimer</Link>
              <Link to="/contact-us">Contact</Link>
            </div>
          </div>
        </div>
      </footer>

      <div className="scroll-progress d-none d-xxl-block">
        <Link to="#" className="scroll-top" aria-label="scroll">
          <span className="scroll-text">Scroll</span>
          <span className="scroll-line">
            <span className="scroll-point"></span>
          </span>
        </Link>
      </div>
    </>
  );
};

export default Footer;

